module.exports = __webpack_public_path__ + "static/img/takepaper.226ebcc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/state-ui/takepaper.gif
// module id = Xfyf
// module chunks = 1